import Navi from './Navi.vue';

export default Navi;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/calendar/components/calendar/components/navi/index.ts